// import ClearIcon from "@mui/icons-material/Clear";
// import SearchIcon from "@mui/icons-material/Search";
// import { Box, Button, IconButton, TextField } from "@mui/material";
// import {
//   forwardRef,
//   useCallback,
//   useEffect,
//   useImperativeHandle,
//   useMemo,
//   useState,
// } from "react";
// import { Products } from "../API/Product";
// import { Users } from "../API/Users";
// import { useFilter } from "../customHooks/useFIlters";
// import ClientsFilter from "./ClientsFilter";
// import MultipleSelectCheckmarks from "./MultipleSelectCheckmarks";

// type AccountFilterProps = {
//   typeData: any;
//   onSearch: Function;
//   filter: Function;
// };

// const AccountFilter = forwardRef(
//   ({ typeData, onSearch, filter }: AccountFilterProps, ref) => {
//     const { setFilter, resetFilter, getFilter } = useFilter();

//     const [hasFilter, setHasFilter] = useState(false);
//     const [levelFilter, setLevelFilter] = useState<string[]>(
//       (getFilter("levelFilter") as string[]) ?? []
//     );
//     const [ownerFilter, setOwnerFilter] = useState<string[]>(
//       (getFilter("ownerFilter") as string[]) ?? []
//     );
//     const [groupFilter, setGroupFilter] = useState<string[]>(
//       (getFilter("groupFilter") as string[]) ?? []
//     );
//     const [productFilter, setProductFilter] = useState<string[]>(
//       (getFilter("productFilter") as string[]) ?? []
//     );
//     const [userStatusFilter, setUserStatusFilter] = useState<string[]>(
//       (getFilter("userStatusFilter") as string[]) ?? []
//     );

//     const clearFilters = useCallback(
//       (_filter: "type" | "owner" | "group" | "product" | null) => {
//         switch (_filter) {
//           case "group":
//             setGroupFilter([]);
//             break;
//           case "owner":
//             setOwnerFilter([]);
//             break;
//           case "product":
//             setProductFilter([]);
//             break;
//           case "type":
//             setLevelFilter([]);
//             break;
//           default:
//             setGroupFilter([]);
//             setOwnerFilter([]);
//             setProductFilter([]);
//             setLevelFilter([]);
//             setUserStatusFilter(["true"]);
//             break;
//         }
//         resetFilter();
//       },
//       [resetFilter]
//     );
//     useEffect(() => {
//       const allFilters = [
//         ...levelFilter,
//         ...ownerFilter,
//         ...groupFilter,
//         ...productFilter,
//       ];

//       const statusFilter = userStatusFilter.length;
//       if (
//         allFilters.length === 0 &&
//         statusFilter === 1 &&
//         userStatusFilter[0] === "true"
//       ) {
//         setHasFilter(false);
//       } else {
//         setHasFilter(true);
//       }
//     }, [
//       groupFilter,
//       ownerFilter,
//       levelFilter,
//       productFilter,
//       userStatusFilter,
//     ]);

//     const userAPI = useMemo(() => new Users(), []);
//     const productsAPI = useMemo(() => new Products(), []);
//     const clearSearch = useCallback(() => {
//       setSearchConten("");
//     }, []);

//     const [isInputDisabled, setIsInputDisabled] = useState(false);
//     useImperativeHandle(
//       ref,
//       () => ({
//         refresh: () => {
//           setLevelFilter(getFilter("levelFilter") as string[]);
//           setOwnerFilter(getFilter("ownerFilter") as string[]);
//           setGroupFilter(getFilter("groupFilter") as string[]);
//           setProductFilter(getFilter("productFilter") as string[]);
//           setUserStatusFilter(getFilter("userStatusFilter") as string[]);
//           setUserStatusFilter(getFilter("userStatusFilter") as string[]);
//           clearSearch();
//         },
//         disableInputSearch: () => setIsInputDisabled(true),
//         enableInputSearch: () => setIsInputDisabled(false),
//       }),
//       [clearSearch, getFilter]
//     );

//     const [type, setType] =
//       useState<{ label: string; value: string; checked: boolean }[]>(typeData);
//     useEffect(() => setType(typeData), [typeData]);

//     const typeCheckHandler = useCallback(
//       (values: any) => {
//         setLevelFilter(values);
//         setFilter("levelFilter", values);
//         clearSearch();
//         filter();
//       },
//       [clearSearch, filter, setFilter]
//     );
//     const [owner, setOwner] = useState<
//       { label: string; value: string; checked: boolean }[]
//     >([]);
//     const onOpenOwnersFilter = useCallback(async () => {
//       let sellers = await userAPI.getOwners();
//       if (sellers.status === "OK") {
//         sellers = sellers.data.owners;

//         const arr: any = [];
//         sellers.forEach((element: any) => {
//           arr.push({
//             label: element,
//             value: element,
//             checked: false,
//           });
//         });
//         setOwner(arr);
//       }
//     }, [userAPI]);
//     const ownerCheckHandler = useCallback(
//       (values: any) => {
//         setOwnerFilter(values);
//         setFilter("ownerFilter", values);
//         filter();
//         clearSearch();
//       },
//       [clearSearch, filter, setFilter]
//     );

//     //#region - products
//     const [products, setProducts] = useState<
//       { label: string; value: string; checked: boolean }[]
//     >([]);
//     const producstCheckHandler = useCallback(
//       (values: any) => {
//         setProductFilter(values);
//         setFilter("productFilter", values);
//         filter();
//         clearSearch();
//       },
//       [clearSearch, filter, setFilter]
//     );
//     const onOpenProductsFilter = useCallback(async () => {
//       if (products.length <= 0) {
//         let _products = await productsAPI.getAllProducts();
//         _products = _products.data.products;
//         _products = _products.map((item: any) => ({
//           label: item.codeName,
//           value: item.id,
//           checked: false,
//         }));
//         setProducts(_products);
//       }
//     }, [products, productsAPI]);
//     //#endregion

//     const statusCheckHandler = useCallback(
//       (values: any) => {
//         setUserStatusFilter(values);
//         setFilter("userStatusFilter", values);
//         setSearchConten("");
//         clearSearch();
//         filter();
//       },
//       [clearSearch, filter, setFilter]
//     );

//     const clientsCheckHandler = useCallback(
//       (values: any) => {
//         setGroupFilter(values);
//         setFilter("groupFilter", values);
//         clearSearch();
//         filter();
//       },
//       [clearSearch, filter, setFilter]
//     );
//     //#endregion

//     //delaying the setSearchFilter to avoid http requests
//     const [timer, setTimer] = useState<any>(null);
//     const [searchContent, setSearchConten] = useState("");
//     const onSearchContentChange = useCallback(
//       (e: any) => {
//         const textValue = e.target.value;
//         setSearchConten(textValue);
//         if (timer) {
//           clearTimeout(timer);
//           setTimer(null);
//         }
//         setTimer(
//           setTimeout(() => {
//             onSearch(textValue);
//             clearFilters(null);
//           }, 500)
//         );
//       },
//       [clearFilters, onSearch, timer]
//     );

//     return (
//       <Box display={"flex"} gap={1} alignItems={"center"} flexWrap={"wrap"}>
//         <MultipleSelectCheckmarks
//           data={type}
//           values={levelFilter}
//           onChangeValues={typeCheckHandler}
//           label={"Type"}
//         />
//         <MultipleSelectCheckmarks
//           data={owner}
//           onOpen={onOpenOwnersFilter}
//           values={ownerFilter}
//           onChangeValues={ownerCheckHandler}
//           label={"Owner"}
//         />
//         <ClientsFilter
//           values={groupFilter}
//           onChangeValues={clientsCheckHandler}
//         />
//         <MultipleSelectCheckmarks
//           data={products}
//           values={productFilter}
//           onChangeValues={producstCheckHandler}
//           onOpen={onOpenProductsFilter}
//           label={"Products"}
//         />
//         <MultipleSelectCheckmarks
//           data={[
//             { label: "Active", value: "true", checked: true },
//             { label: "Not active", value: "false", checked: false },
//           ]}
//           values={userStatusFilter}
//           onChangeValues={statusCheckHandler}
//           label={"Status"}
//         />
//         <Button
//           color="secondary"
//           size="small"
//           disabled={!hasFilter}
//           onClick={() => {
//             clearFilters(null);
//             filter();
//           }}
//         >
//           Clear filter
//         </Button>

//         <Box
//           flex={1}
//           textAlign={"right"}
//           justifyContent={"flex-end"}
//           display={"flex"}

//         >
//           {/* <Divider orientation="vertical" flexItem /> */}
//           <TextField
//           autoFocus
//             disabled={isInputDisabled}
//             placeholder="Search"
//             size="small"
//             value={searchContent}
//             inputProps={{
//               autoComplete: "off",
//             }}
//             InputProps={{
//               endAdornment: (
//                 <IconButton
//                   onClick={() => {
//                     if (searchContent.length > 0) {
//                       setSearchConten("");
//                       clearFilters(null);
//                       filter();
//                     }
//                   }}
//                 >
//                   {searchContent.length > 0 ? <ClearIcon /> : <SearchIcon />}
//                 </IconButton>
//               ),
//             }}
//             onChange={onSearchContentChange}
//           />
//         </Box>
//       </Box>
//     );
//   }
// );

// export default AccountFilter;

import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Divider, IconButton, TextField } from "@mui/material";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { Products } from "../API/Product";
import { Users } from "../API/Users";
import { useFilter } from "../customHooks/useFIlters";
import ClientsFilter from "./ClientsFilter";
import MultipleSelectCheckmarks from "./MultipleSelectCheckmarks";

type AccountFilterProps = {
  typeData: any;
  onSearch: (text: string) => void;
  filter: () => void;
};

type Option = { label: string; value: string; checked: boolean };
// type FilterKey = "type" | "owner" | "group" | "product" | "status" | null;

/**
 * NOTE (comportamento scelto):
 * - La search "esclude" i filtri: quando parte una search (dopo debounce), i filtri vengono azzerati.
 * - Quando l'utente cambia un filtro, la search viene cancellata e svuotata (per evitare race condition).
 *
 * Se vuoi invece "search + filtri" insieme, è sufficiente rimuovere `clearAllFilters()` dentro il timeout
 * e non azzerare la search negli handlers dei filtri.
 */
const AccountFilter = forwardRef(
  ({ typeData, onSearch, filter }: AccountFilterProps, ref) => {
    const { setFilter, resetFilter, getFilter } = useFilter();

    // ---------------------------
    // Helpers: debounce robusto
    // ---------------------------
    const searchTimerRef = useRef<number | null>(null);

    const cancelPendingSearch = useCallback(() => {
      if (searchTimerRef.current !== null) {
        clearTimeout(searchTimerRef.current);
        searchTimerRef.current = null;
      }
    }, []);

    // Cleanup: evita callback che partono dopo unmount
    useEffect(() => {
      return () => cancelPendingSearch();
    }, [cancelPendingSearch]);

    // ---------------------------
    // Stato filtri (con fallback)
    // ---------------------------
    const [levelFilter, setLevelFilter] = useState<string[]>(
      (getFilter("levelFilter") as string[]) ?? []
    );
    const [ownerFilter, setOwnerFilter] = useState<string[]>(
      (getFilter("ownerFilter") as string[]) ?? []
    );
    const [groupFilter, setGroupFilter] = useState<string[]>(
      (getFilter("groupFilter") as string[]) ?? []
    );
    const [productFilter, setProductFilter] = useState<string[]>(
      (getFilter("productFilter") as string[]) ?? []
    );
    const [userStatusFilter, setUserStatusFilter] = useState<string[]>(
      (getFilter("userStatusFilter") as string[]) ?? ["true"]
    );

    // Stato UI
    const [hasFilter, setHasFilter] = useState(false);
    const [isInputDisabled, setIsInputDisabled] = useState(false);

    // Stato search
    const [searchContent, setSearchConten] = useState("");

    // ---------------------------
    // API
    // ---------------------------
    const userAPI = useMemo(() => new Users(), []);
    const productsAPI = useMemo(() => new Products(), []);

    // ---------------------------
    // Calcolo hasFilter coerente
    // ---------------------------
    useEffect(() => {
      const allFilters = [
        ...levelFilter,
        ...ownerFilter,
        ...groupFilter,
        ...productFilter,
      ];

      const statusIsDefault =
        userStatusFilter.length === 1 && userStatusFilter[0] === "true";

      // "ha filtri" se qualsiasi filtro non è default
      setHasFilter(!(allFilters.length === 0 && statusIsDefault));
    }, [
      groupFilter,
      ownerFilter,
      levelFilter,
      productFilter,
      userStatusFilter,
    ]);

    // ---------------------------
    // Clear search
    // - cancella anche eventuali debounce pendenti
    // ---------------------------
    const clearSearch = useCallback(() => {
      cancelPendingSearch();
      setSearchConten("");
    }, [cancelPendingSearch]);

    // ---------------------------
    // Reset filtri: separa chiaramente
    // - stato locale
    // - store (useFilter)
    // ---------------------------
    const clearAllFilters = useCallback(() => {
      setGroupFilter([]);
      setOwnerFilter([]);
      setProductFilter([]);
      setLevelFilter([]);
      setUserStatusFilter(["true"]);

      // Reset globale dello store (coerente col reset totale)
      resetFilter();
    }, [resetFilter]);

    /**
     * Se vuoi supportare reset "parziale" (es. solo owner),
     * NON usare resetFilter() globale perché azzera tutto nello store.
     * Qui aggiorniamo lo store puntualmente.
     */
    // const clearSingleFilter = useCallback(
    //   (key: Exclude<FilterKey, null>) => {
    //     switch (key) {
    //       case "group":
    //         setGroupFilter([]);
    //         setFilter("groupFilter", []);
    //         break;
    //       case "owner":
    //         setOwnerFilter([]);
    //         setFilter("ownerFilter", []);
    //         break;
    //       case "product":
    //         setProductFilter([]);
    //         setFilter("productFilter", []);
    //         break;
    //       case "type":
    //         setLevelFilter([]);
    //         setFilter("levelFilter", []);
    //         break;
    //       case "status":
    //         setUserStatusFilter(["true"]);
    //         setFilter("userStatusFilter", ["true"]);
    //         break;
    //     }
    //   },
    //   [setFilter]
    // );

    // ---------------------------
    // Exposed methods via ref
    // ---------------------------
    useImperativeHandle(
      ref,
      () => ({
        refresh: () => {
          // Cancella debounce pendenti, evita side effects fuori tempo
          cancelPendingSearch();

          setLevelFilter((getFilter("levelFilter") as string[]) ?? []);
          setOwnerFilter((getFilter("ownerFilter") as string[]) ?? []);
          setGroupFilter((getFilter("groupFilter") as string[]) ?? []);
          setProductFilter((getFilter("productFilter") as string[]) ?? []);
          setUserStatusFilter(
            (getFilter("userStatusFilter") as string[]) ?? ["true"]
          );

          setSearchConten("");
        },
        disableInputSearch: () => setIsInputDisabled(true),
        enableInputSearch: () => setIsInputDisabled(false),
      }),
      [cancelPendingSearch, getFilter]
    );

    // ---------------------------
    // Type options
    // ---------------------------
    const [type, setType] = useState<Option[]>(typeData);
    useEffect(() => setType(typeData), [typeData]);

    // ---------------------------
    // Handlers filtri
    // Regola: quando l'utente interagisce coi filtri:
    // - cancello debounce pendenti
    // - svuoto la search (evito che un vecchio timeout resetti filtri/risultati)
    // - aggiorno store
    // - chiamo filter()
    // ---------------------------
    const typeCheckHandler = useCallback(
      (values: string[]) => {
        clearSearch();
        setLevelFilter(values);
        setFilter("levelFilter", values);
        filter();
      },
      [clearSearch, filter, setFilter]
    );

    const [owner, setOwner] = useState<Option[]>([]);
    const onOpenOwnersFilter = useCallback(async () => {
      const sellers = await userAPI.getOwners();
      if (sellers.status === "OK") {
        const arr: Option[] = sellers.data.owners.map((element: string) => ({
          label: element,
          value: element,
          checked: false,
        }));
        setOwner(arr);
      }
    }, [userAPI]);

    const ownerCheckHandler = useCallback(
      (values: string[]) => {
        clearSearch();
        setOwnerFilter(values);
        setFilter("ownerFilter", values);
        filter();
      },
      [clearSearch, filter, setFilter]
    );

    // Products
    const [products, setProducts] = useState<Option[]>([]);
    const producstCheckHandler = useCallback(
      (values: string[]) => {
        clearSearch();
        setProductFilter(values);
        setFilter("productFilter", values);
        filter();
      },
      [clearSearch, filter, setFilter]
    );

    const onOpenProductsFilter = useCallback(async () => {
      if (products.length > 0) return;

      let _products = await productsAPI.getAllProducts();
      const mapped: Option[] = _products.data.products.map((item: any) => ({
        label: item.codeName,
        value: item.id,
        checked: false,
      }));
      setProducts(mapped);
    }, [products.length, productsAPI]);

    // Status
    const statusCheckHandler = useCallback(
      (values: string[]) => {
        clearSearch();
        setUserStatusFilter(values);
        setFilter("userStatusFilter", values);
        filter();
      },
      [clearSearch, filter, setFilter]
    );

    // Clients
    const clientsCheckHandler = useCallback(
      (values: string[]) => {
        clearSearch();
        setGroupFilter(values);
        setFilter("groupFilter", values);
        filter();
      },
      [clearSearch, filter, setFilter]
    );

    // ---------------------------
    // Search: debounce con ref (no state), senza race condition
    // ---------------------------
    const onSearchContentChange = useCallback(
      (e: any) => {
        const textValue = e.target.value;
        setSearchConten(textValue);

        // Cancella eventuale ricerca pendente
        cancelPendingSearch();

        // Se vuoi evitare chiamate vuote, puoi gestire qui:
        // if (textValue.trim().length === 0) { ... }

        searchTimerRef.current = window.setTimeout(() => {
          // 1) parte la search
          onSearch(textValue);

          // 2) comportamento scelto: la search esclude i filtri (reset totale)
          //    Lo facciamo qui in modo intenzionale e consistente.
          clearAllFilters();
        }, 500);
      },
      [cancelPendingSearch, clearAllFilters, onSearch]
    );

    // ---------------------------
    // UI
    // ---------------------------
    return (
      <Box display={"flex"} gap={1} flexDirection={"column"} alignItems={"center"}>
        <Box width={"100%"} display={"flex"} alignItems={"center"} gap={1}>
          <MultipleSelectCheckmarks
            data={type}
            values={levelFilter}
            onChangeValues={typeCheckHandler}
            label={"Type"}
          />

          <MultipleSelectCheckmarks
            data={owner}
            onOpen={onOpenOwnersFilter}
            values={ownerFilter}
            onChangeValues={ownerCheckHandler}
            label={"Owner"}

          />

          <ClientsFilter
            values={groupFilter}
            onChangeValues={clientsCheckHandler}
          />

          <MultipleSelectCheckmarks
            data={products}
            values={productFilter}
            onChangeValues={producstCheckHandler}
            onOpen={onOpenProductsFilter}
            label={"Products"}
          />

          <MultipleSelectCheckmarks
            data={[
              { label: "Active", value: "true", checked: true },
              { label: "Not active", value: "false", checked: false },
            ]}
            values={userStatusFilter}
            onChangeValues={statusCheckHandler}
            label={"Status"}
          />

          <Button
            color="secondary"
            size="small"
            disabled={!hasFilter}
            onClick={() => {
              // Clear totale (UI + store) e refresh risultati
              cancelPendingSearch();
              clearAllFilters();
              clearSearch(); // opzionale, ma coerente con reset totale
              filter();
            }}
          >
            Clear filter
          </Button>
        </Box>
        
        <Box display={"flex"} width={"100%"}>
          <TextField
            
            // autoFocus
            sx={{minWidth: '30%', maxWidth:"50%", width: 'auto', display:"flex"}}
            disabled={isInputDisabled}
            placeholder="Search"
            size="small"
            value={searchContent}
            inputProps={{
              autoComplete: "off",
              autoCorrect: "off",
              spellCheck: "false",
              style: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => {
                    // Click sull'icona: comportamento immediato e consistente
                    if (searchContent.length > 0) {
                      cancelPendingSearch();
                      setSearchConten("");
                      // Ripristino filtri e risultati standard
                      clearAllFilters();
                      filter();
                    }
                  }}
                >
                  {searchContent.length > 0 ? <ClearIcon /> : <SearchIcon />}
                </IconButton>
              ),
            }}
            onChange={onSearchContentChange}
          />
        </Box>
        <Divider orientation="horizontal" flexItem sx={{width: '100%'}} />
      </Box>
    );
  }
);

export default AccountFilter;
